import React from 'react';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="logo">Tresto Admin</div>
      <ul className="menu">
        <li className="menu-item active">Dashboard</li>
        <li className="menu-item">Analytics</li>
        <li className="menu-item">Marketing</li>
        <li className="menu-item">Operations</li>
        <li className="menu-item">Settings</li>
        <li className="menu-item">Logout</li>
      </ul>
    </div>
  );
};

export default Sidebar;
